<template>
  <div class="staff-StaffSelector">
    <template v-if="disabled">
      <template v-if="!option.hideInfo">
        <worker-info :ids="findStaff.map((o) => o.id)" />
      </template>
      <template v-else>
        <span class="text-primary">
          <!-- {{ findStaff.map(o => o.name).join() }} -->
          {{ findStaff | nameFormat }}
        </span>
      </template>
      <span class="text-primary">
        <!-- {{ findStaff.map(o => o.enName).join() }} -->
        <!-- {{ findStaff.map(o => o.name).join() }} -->
      </span>
    </template>
    <div v-else class="staff-StaffSelector_content" @click="handleVisible">
      <!-- 未选中员工 -->
      <span v-if="!value" class="placeholder">
        <span>{{ placeholder }}</span>

        <feather-icon
          icon="ChevronDownIcon"
          class="placeholder-icon"
          size="20"
        />
      </span>
      <!-- 已选中员工 -->
      <span v-else class="hasValue">
        <!-- 选择器为多选时，选中人员展示 -->
        <div v-if="multiple" style="width: calc(100% - 50px);">
          <a-tag
            v-for="(item, i) in findStaff"
            :key="i"
            class="mt-0-5"
            closable
            @close="delCheckedStaff($event, item.id)"
          >
            <!-- {{ item.enName }} -->
            {{ item.name }}
          </a-tag>
        </div>
        <!-- 选择器为单选时，选中人员展示 -->
        <span v-else>{{ findStaff.map((o) => o.name).join() }}</span>
        <feather-icon
          icon="XCircleIcon"
          class="hasValue-icon"
          size="16"
          @click.stop="clearValue"
        />
        <feather-icon
          icon="ChevronDownIcon"
          class="placeholder-icon"
          size="20"
        />
      </span>
    </div>

    <!-- 员工选择器 -->
    <c-modal
      :visible="visible"
      title="Worker selector"
      size="lg"
      body-class="staff-selector-modal_body"
      footer-class="staff-selector-modal_footer"
      @close="close"
      @modelConfirm="handleModelConfirm"
      @confirmEnter="hoverConfirm = true"
      @confirmLeave="hoverConfirm = false"
    >
      <template slot="content">
        <div class="selector-content">
          <!-- 人员选择器Tab分栏 -->
          <b-tabs v-model="currentTab" align="left">
            <!-- 查询历史分栏 -->
            <b-tab :title="i18n('selector.recently')" />
            <b-tab :title="'Search'" />

            <b-tab :title="'Project'">
              <b-overlay
                :show="teamLoading"
                rounded="sm"
                class="overlay-box my-border"
                :class="{ 'my-border__hover': deptLoaded }"
              >
                <tree-list
                  :data="teamsTreeData"
                  :props="teamsProps"
                  @checkItem="handleTeamsCheck"
                />
              </b-overlay>
            </b-tab>
          </b-tabs>
          <!-- 分栏Tab的公共显示区域 -->
          <div class="staff-search">
            <b-form-input
              v-model="searchWorker"
              :placeholder="$t('_components.placeholder.input') + 'worker'"
              type="text"
            />
            <!-- or number -->
            <b-button
              v-if="currentTab === 1"
              variant="primary"
              size="sm"
              @click="handleSearchWorker"
            >
              {{ i18n('btns.search') }}
            </b-button>
          </div>
          <!--  -->
          <!-- 工人查询列表 -->
          <div
            class="staff-list my-border"
            :class="{
              'staff-list__maxheight': currentTab === 0 || currentTab === 1,
              'my-border__hover': staffLoaded,
            }"
          >
            <b-overlay
              :show="workerListLoading"
              rounded="sm"
              style="display: inline-block"
            >
              <div style="width: 100%;height: 350px;overflow: scroll;">
                <template v-for="(item, i) in workerData">
                  <template v-if="multiple">
                    <b-form-checkbox
                      :key="i"
                      v-model="chcekedStaff"
                      class="staff-list__item"
                      :class="{
                        'staff-list__item-checked': !!chcekedStaffResult.find(
                          (o) => o.id === item.id
                        ),
                      }"
                      :value="item.id"
                    >
                      {{ item.name }} {{ item.code || item.employmentCode }}
                    </b-form-checkbox>
                  </template>
                  <div
                    v-else
                    :key="i"
                    class="staff-list__item"
                    :class="{
                      'staff-list__item-checked':
                        chcekedStaff.indexOf(item.id) != -1,
                    }"
                    @click="handleStaffClick(item)"
                  >
                    {{ item.name }} {{ item.code || item.employmentCode }}
                  </div>
                </template>
              </div>

              <div
                style="width: 100%;height: 30px;margin-top: 5px"
                v-if="currentTab == 1"
              >
                <b-pagination
                  v-model="navPage.currentPage"
                  :total-rows="navPage.total"
                  :per-page="navPage.pageSize"
                  first-number
                  last-number
                  prev-class="prev-item"
                  next-class="next-item"
                  @change="navPageChange"
                >
                  <template #prev-text>
                    <feather-icon icon="ChevronLeftIcon" size="18" />
                  </template>
                  <template #next-text>
                    <feather-icon icon="ChevronRightIcon" size="18" />
                  </template>
                </b-pagination>
              </div>
            </b-overlay>
          </div>
          <!-- 选中工人列表 -->
          <!-- 将选中的工人左右移动 -->
          <div
            class="checked-staff my-border"
            :class="
              hoverConfirm
                ? chcekedStaffResult.length > 0
                  ? 'my-border__hover'
                  : 'my-border__hover-wrning'
                : ''
            "
          >
            <!-- 操作按钮（控制是否选中） -->
            <div class="checked-staff__btns">
              <div
                :class="
                  chcekedStaff.length > 0 ? 'not-disabled' : 'is-disabled'
                "
                @click="handleMoveRes"
              >
                <feather-icon icon="ChevronRightIcon" size="20" />
              </div>
              <div
                :class="
                  chcekedResStaff.length > 0 ? 'not-disabled' : 'is-disabled'
                "
                @click="handleClearRes"
              >
                <feather-icon icon="ChevronLeftIcon" size="20" />
              </div>
            </div>
            <!-- 选中数据展示 -->
            <div class="checked-staff__content">
              <template v-for="(item, i) in chcekedStaffResult">
                <b-form-checkbox
                  v-if="multiple"
                  :key="i"
                  v-model="chcekedResStaff"
                  class="staff-list__item"
                  :value="item.id"
                >
                  <!-- disabled-theme -->
                  <!-- {{ item.enName }} -->
                  <!-- {{ isDisabled(item) }} -->
                  {{ item.name }} {{ item.code || item.employmentCode }}
                </b-form-checkbox>
                <div
                  v-else
                  :key="i"
                  class="staff-list__item"
                  :class="{
                    'staff-list__item-checked':
                      chcekedResStaff.indexOf(item.id) != -1,
                  }"
                  @click="handleResStaffClick(item)"
                >
                  {{ item.name }} {{ item.code || item.employmentCode }}
                </div>
              </template>
            </div>
          </div>
        </div>
      </template>
    </c-modal>
  </div>
</template>

<script>
import TreeList from '@/components/treeList.vue'
import {
  BTab,
  BTabs,
  BOverlay,
  BFormCheckbox,
  BFormInput,
  BButton,
  BPagination,
} from 'bootstrap-vue'
import { deptTree, getList as getDeptList } from '@/api/system/dept'
import WORKER from '@/api/worker/index'
// 通过project 获取Teams 列表
import WORKERTEAMS from '@/api/worker/workTeams'
import { mapGetters } from 'vuex'
import { staff } from '@/api/staff/index'
import projectAPI from '@/api/base/project'
import { deepClone } from '@/util/util'
import workerInfo from './workerInfo.vue'

export default {
  components: {
    CModal: () => import('@/components/crud/modal.vue'),
    BTab,
    BTabs,
    TreeList,
    BOverlay,
    BFormCheckbox,
    BPagination,
    BFormInput,
    BButton,
    workerInfo,
  },
  filters: {
    nameFormat(item) {
      return item.map((o) => `${o.name}(${o.employmentCode})`).join()
    },
  },
  props: {
    value: {
      type: [String, Number, Object, Array, Boolean],
      default: undefined,
    },
    /**
     * multiple  是否多选
     * hasSupervisor  是否显示工长  true 不显示
     * isQuickTransition 是否是快速转场流程
     */
    option: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentTab: 1,
      visible: false,
      // 选中员工 相关参数
      chcekedStaff: [],
      chcekedStaffResult: [],
      chcekedResStaff: [],
      checkedStaffData: [],
      // 查询员工参数
      staffData: [],
      workerData: [],
      navPage: {
        pageSize: 20,
        currentPage: 1,
        total: 12,
      },

      teamLoading: false,
      // 班组数据
      teamsTreeData: [],
      checkedTeam: false,

      hoverConfirm: false,
      staffLoaded: false,
      multiple: false,
      workerListLoading: false,

      query: this.option.dictQuery,
      searchWorker: '',
    }
  },
  computed: {
    ...mapGetters(['language', 'recentlyUser']),
    placeholder() {
      return this.option.placeholder
        ? this.option.placeholder
        : this.$t('_components.placeholder.input') + this.label
    },
    teamsProps() {
      return {
        label: 'projectName',
        value: 'id',
        children: 'children',
        props: {
          label: 'teamName',
          value: 'id',
          children: 'children',
        },
      }
    },
    findStaff() {
      let find = []
      if (this.value) {
        const valArr = this.value.split(',')
        find =
          this.checkedStaffData.filter(
            (o) => valArr.indexOf(o.id.toString()) !== -1
          ) || []
        if (find.length <= 0) {
          find =
            this.staffData.filter(
              (o) => valArr.indexOf(o.id.toString()) !== -1
            ) || []
        }
      }
      return find
    },
    recentlyStaff() {
      return this.recentlyUser.staff || []
    },
  },
  watch: {
    value(e) {},
    currentTab: {
      deep: true,
      handler(e) {
        this.onload()
      },
    },
    'option.multiple': {
      handler(e) {
        this.multiple = e || false
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    if (this.value && this.staffData.length <= 0) {
      this.workerListLoading = true
      const query = deepClone(this.option.dictQuery)
      WORKER.getAllEasyList(1, -1, { ids: this.value, ...query }).then(
        (res) => {
          // const temp = res.data.data.records
          const temp = res.data.data.records
          this.staffData = temp
          this.workerListLoading = false
          this.staffLoaded = true
          setTimeout(() => {
            this.staffLoaded = false
          }, 500)
        }
      )
    }
  },
  methods: {
    handleVisible() {
      this.visible = true
      this.onload()
    },
    isDisabled(item) {
      return item.teamMemberStatus === '转场中'
    },
    // 获取project 树形列表
    async getProjectTreeList() {
      const projectObj = await projectAPI.getList1(1, -1)
      const teamsObj = await WORKER.getTeamList(1, -1)
      Promise.all([projectObj, teamsObj]).then((values) => {
        const projectList = values[0].data.data.records
        const teamsList = values[1].data.data
        this.teamsTreeData = this.getTreeList(projectList, teamsList)
        this.teamLoading = false
        this.deptLoaded = false
      })
    },
    getTreeList(project, teamsList) {
      const temp1 = []
      project.forEach((el) => {
        const tempObj = el
        tempObj.children = []
        temp1.push(tempObj)
      })
      const data = temp1.concat(teamsList)
      const treeList = []
      const obj = {}
      data.forEach((el) => {
        if (el.projectName && !obj[el.id]) {
          obj[el.id] = el
        }
        if (!el.projectName) {
          if (obj[el.projectId]) {
            obj[el.projectId].children.push(el)
          }
        }
      })
      Object.entries(obj).forEach((item) => {
        treeList.push(item[1])
      })

      return treeList
    },
    onload() {
      this.searchWorker = ''
      this.navPage.currentPage = 1
      this.chcekedStaffResult = this.findStaff
      if (this.currentTab === 0) {
        this.workerData = [...this.recentlyStaff]
      } else if (this.currentTab === 1) {
        // this.staffData = []
        if (!this.disabled) {
          this.workerListLoading = true
          // console.log(this.option, 'option+===')
          const query = deepClone(this.option.dictQuery)
          WORKER.getAllEasyList(
            this.navPage.currentPage,
            this.navPage.pageSize,
            query
          ).then((res) => {
            const temp = res.data.data.records
            // if(this.option && this.option.isQuickTransition) {
            //   temp.filter(el => el.)
            // }
            this.navPage.currentPage = res.data.data.current
            this.navPage.total = res.data.data.total

            this.workerData = temp.filter((el) => {
              // 判断如果不需要显示工长的流程过滤工长
              if (this.option.hasSupervisor) {
                return el.isSupervisor !== 1
              }
              return el
            })
            // this.staffData = temp
            this.workerListLoading = false
            // this.staffLoaded = true
            // setTimeout(() => {
            //   this.staffLoaded = false
            // }, 500);
          })
        }
      } else if (this.currentTab === 2) {
        this.workerData = []
        if (this.teamsTreeData.length <= 0) {
          this.teamLoading = true
          this.deptLoaded = true
          this.getProjectTreeList()
          WORKER.getTeamList().then((res) => {
            this.teamLoading = false
            this.deptLoaded = false
            this.teamsTreeData = res.data.data
            setTimeout(() => {
              this.deptLoaded = false
            }, 500)
          })
        } else if (this.checkedTeam) {
          this.handleTeamsCheck(this.checkedTeam)
        }
      }
    },
    handleTeamsCheck(e) {
      this.checkedTeam = typeof e === 'object' ? e.id : e
      this.workerListLoading = true
      WORKERTEAMS.getTeamsTreeList1(1, -1, { id: this.checkedTeam }).then(
        (res) => {
          const lists = res.data.data.records
          const lists1 = lists.map((el) => ({
            id: el.workerId,
            name: el.name,
            code: el.code,
          }))
          this.workerData = lists1
          this.staffLoaded = true
          this.workerListLoading = false
          setTimeout(() => {
            this.staffLoaded = false
          }, 500)
        }
      )
    },
    handleStaffClick(e) {
      this.chcekedStaff = [e.id]
    },
    handleResStaffClick(e) {
      this.chcekedResStaff = [e.id]
    },
    handleModelConfirm() {
      this.visible = false
      this.checkedStaffData = this.chcekedStaffResult
      const res = this.chcekedStaffResult.map((o) => o.id).join()

      const { recentlyStaff } = this
      this.chcekedStaffResult.forEach((item) => {
        if (!recentlyStaff.find((o) => o.id === item.id)) {
          recentlyStaff.push(item)
        }
      })
      const temp = this.recentlyUser
      temp.staff = recentlyStaff
      this.$store.commit('SET_RECENTLY_USER', temp)

      this.$emit('input', res)
    },
    delCheckedStaff(e, id) {
      e.preventDefault()
      const temp = []
      this.findStaff.forEach((item) => {
        if (item.id !== id) {
          temp.push(item)
        }
      })
      this.findStaff = [...temp]
      const res = temp.map((o) => o.id).join()
      this.$emit('input', res)
    },
    navPageChange(e) {
      this.navPage.currentPage = e
      this.workerListLoading = true
      const query = deepClone(this.option.dictQuery)
      WORKER.getAllEasyList(this.navPage.currentPage, this.navPage.pageSize, {
        ...query,
        nameOrNo: this.searchWorker,
      }).then((res) => {
        const temp = res.data.data.records
        this.workerData = temp
        this.workerListLoading = false
        this.staffLoaded = true
        this.navPage.currentPage = res.data.data.current
        this.navPage.total = res.data.data.total
        console.log(this.navPage)
        // setTimeout(() => {
        //   this.staffLoaded = false
        // }, 500);
      })
    },
    handleMoveRes() {
      const filter = this.workerData.filter(
        (o) => this.chcekedStaff.indexOf(o.id) !== -1
      )
      if (!this.multiple) {
        this.chcekedStaffResult = [...filter]
      } else {
        const temp = [...this.chcekedStaffResult]
        filter.forEach((item) => {
          if (!temp.find((o) => o.id === item.id)) {
            temp.push(item)
          }
        })
        this.chcekedStaffResult = temp
      }
      this.chcekedStaff = []
      this.hoverConfirm = true
      setTimeout(() => {
        this.hoverConfirm = false
      }, 500)
    },
    handleClearRes() {
      const temp = []
      this.chcekedStaffResult.forEach((item) => {
        if (this.chcekedResStaff.indexOf(item.id) === -1) {
          temp.push(item)
        }
      })
      this.chcekedStaffResult = temp
      this.chcekedResStaff = []
      this.hoverConfirm = true
      setTimeout(() => {
        this.hoverConfirm = false
      }, 500)
    },
    close() {
      this.visible = false
      this.hoverConfirm = false
    },
    clearValue() {
      this.chcekedStaffResult = []
      this.chcekedResStaff = []
      this.$emit('input', '')
    },
    handleTeamDisabled(e) {
      return e.deptType !== 3
    },
    handleSearchWorker() {
      this.navPage.currentPage = 1
      this.workerListLoading = true
      const query = deepClone(this.option.dictQuery)
      WORKER.getAllEasyList(this.navPage.currentPage, this.navPage.pageSize, {
        ...query,
        nameOrNo: this.searchWorker,
      }).then((res) => {
        const temp = res.data.data.records
        this.workerData = temp
        this.workerListLoading = false
        this.staffLoaded = true
        this.navPage.currentPage = res.data.data.current
        this.navPage.total = res.data.data.total
        // setTimeout(() => {
        //   this.staffLoaded = false
        // }, 500);
      })
    },
    // 国际化
    i18n(param) {
      return this.$t(`_components.${param}`)
    },
  },
}
</script>

<style lang="scss" scoped>
.staff-StaffSelector {
  padding: 0 2px;
  width: 100%;
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  font-feature-settings: 'tnum';
  position: relative;
  display: inline-block;
  outline: 0;
  &_content {
    display: block;
    cursor: pointer;
    padding: 0 15px 0 11px;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #d9d9d9;
    border-top: 1.02px solid #d9d9d9;
    border-radius: 4px;
    outline: none;
    user-select: none;
    min-height: 2.714rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 2.714rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s;
    &:hover {
      box-shadow: 0 0 0 2px rgb(24 144 255 / 20%);
    }

    .placeholder,
    .hasValue {
      display: inline-block;
      position: relative;
      width: 100%;
      line-height: 20px;
      &-icon {
        position: absolute;
        color: #bfbfbf;
        right: 0;
        top: 50%;
        transform: translateY(calc(-50% + 2px));
        background-color: #fff;
        z-index: 1;
      }
    }
    .placeholder {
      color: #bfbfbf;
    }
    .hasValue {
      color: rgba(0, 0, 0, 0.65);
      &-icon {
        color: #fff;
        transition: color 0.3s;
      }
    }
    &:hover {
      .hasValue {
        &-icon {
          color: #bfbfbf;
          transition: color 0.3s;
          z-index: 2;
          &:hover {
            color: #797979;
          }
        }
      }
    }
  }
}
.selector-content {
  height: 500px;
  .overlay-box {
    // height: 220px;
    height: 200px;
    width: calc(100% - 15px);
    overflow: auto;
    background-color: #fff;
    padding: 5px 8px;
  }
  .tab-pane {
    width: 50%;
  }

  .staff-search {
    width: calc(50% - 15px);
    margin: 5px 0;
    display: flex;
    .btn {
      margin-left: 5px;
    }
  }

  .staff-list {
    margin-top: 10px;
    height: 200px;
    width: calc(50% - 15px);
    overflow: auto;
    background-color: #fff;
    padding: 5px 4px;
    &__item {
      padding: 0 4px;
      margin: 2px 0;
      border-radius: 5px;
      &:hover,
      &-checked {
        background-color: #eee;
        cursor: pointer;
      }
      &-checked {
        color: #409eff;
        background-color: #cae1fc !important;
      }
    }
    &__maxheight {
      height: 406px;
    }
  }
  .checked-staff {
    height: calc(100% - 71px);
    width: calc(50% - 28px);
    background-color: #fff;
    padding: 5px 4px;
    position: absolute;
    left: calc(50% + 15px);
    top: 61px;
    &__btns {
      position: absolute;
      top: 50%;
      left: -25px;
      transform: translateY(-50%);
      width: 20px;
      & > div {
        width: 100%;
        border-radius: 5px;
        border: 1px solid #ddd;
        background-color: #fff;
        padding: 5px 0;
        cursor: not-allowed;
      }
      & > div:first-child {
        margin-bottom: 10px;
      }
      .not-disabled {
        background-color: #409eff;
        color: #fff;
        cursor: pointer;
        &:hover {
          background-color: #78aff9;
        }
      }
      .is-disabled {
        cursor: not-allowed;
      }
    }
    &__content {
      height: 100%;
      overflow: auto;
      padding: 5px 4px;
    }
    &::before {
      content: '';
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      border: 1px solid #ddd;
      border-radius: 5px;
      z-index: -1;
    }
  }
}
.my-border {
  border-radius: 5px;
  border: 1px solid #ddd;
  transition: border-color 0.15s ease-in-out, box-shadow 0.3s;
  &__hover {
    border: 1px solid #fff !important;
    box-shadow: 0 0 0 4px rgb(24 144 255 / 30%);
  }
  &__hover-wrning {
    box-shadow: 0 0 0 4px rgb(230 162 61 / 30%);
  }
}
.mt-0-5 {
  margin-top: 0.5rem;
}
.disabled-theme {
  color: rgb(192, 196, 204);
}
</style>
<style lang="scss">
.staff-selector-modal_body {
  background-color: #eee;
  padding: 0.8rem 0.8rem !important;
  .custom-control.custom-checkbox {
    padding-left: 1.8rem;
  }
  .custom-control-label {
    cursor: pointer;
    width: 100%;
  }
}
</style>
